<template>
  <div class="wrapper about">
    <op-swiper :slide-list="slideList"></op-swiper>

    <div class="text box-padding"><img src="../../assets/img/about/text.png" alt=""></div>

    <div class="kv box-padding clearfix">
      <div class="col-sm-3 col-xs-6 item">
        <h4>ESTABLISHED</h4>
        <span>2013</span>
        <router-link to="contact">Find and join us</router-link>
      </div>
      <div class="col-sm-3 col-xs-6 item">
        <h4>PROJECTS</h4>
        <span>200 +</span>
        <router-link to="works">Explore our work</router-link>
        <a href=""></a>
      </div>
      <div class="col-sm-3 col-xs-6 item">
        <h4>BRANDS</h4>
        <span>100 +</span>
        <router-link to="service">Search our clients</router-link>
      </div>
      <div class="col-sm-3 col-xs-6 item">
        <h4>INCOME</h4>
        <span>200Billion +</span>
        <router-link to="contact">Contact us</router-link>
      </div>
      <!-- <div class="col-xs-12 logo"><img src="../../assets/img/about/logo.png" alt="" v-show="!isPC"></div> -->
    </div>

    <ul class="list">
      <li v-for="item of listData">
        <h3>{{ $t(item.title) }}</h3>
        <div v-html="$t(item.detailHtml)" class="perview-html"></div>
      </li>
      <li>
        <h3>{{ $t('pages.about.parter') }}</h3>
        <div class="partner-container-div">
        <div class="perview-html partners-container">
          <div class="partners-single" v-for="item of partners">
            <div class="partner-single-div">
              <div class="img-div">
                <img :src="item.imgurl" alt="">
              </div>
              <a :href="item.links">
                <div class="partner-absolute">
                  {{item.content}}
                </div>
              </a>
            </div>
          </div>
        </div>
        <div class=" partners-container-m">
          <div class="partners-single-m" v-for="item of partners2">
            <a :href="item.links"><img :src="item.imgurl" alt=""></a>
          </div>
        </div>
        </div>
      </li>
      <li v-for="item of newsData">
        <h3>{{ $t(item.title) }}</h3>
        <!--<div v-html="$t(item.detailHtml)" class="perview-html"></div>-->
        <div class="perview-html">
          <ul class="news-ul">
            <li v-for="(item, index) of news" class="news-li">
              <router-link :to="{ name: 'news.detail', params: { id: item.id } }" class="news-title" target="_self">
                {{item.zh_cn.title}}
              </router-link>
            </li>
          </ul>
        </div>
      </li>
      <li>
        <h3>{{ $t('pages.about.people') }}</h3>
        <div class="people">
          <!--每行显示一个核心人物-->
          <!--<div class="row" v-for="item of peopleList">-->
            <!--<div class="col-sm-5 col-xs-12 photo">-->
              <!--<img :src="item.photoUrl" alt="">-->
            <!--</div>-->
            <!--<div class="col-sm-7 col-xs-12 info">-->
              <!--<h4>{{item.name}}<span>{{item.title}}</span></h4>-->
              <!--<p v-html="item.intro"></p>-->
            <!--</div>-->
          <!--</div>-->
          <!--每行显示两个核心人物-->
          <!--<div class="people-container">-->
            <!--<div class="people-single" v-for="item of peopleList">-->
              <!--<div class="photo">-->
                <!--<img :src="item.photoUrl" alt="">-->
              <!--</div>-->
              <!--<div class="info">-->
                <!--<h4>{{item.name}}<span>{{item.title}}</span></h4>-->
                <!--<p v-html="item.intro"></p>-->
              <!--</div>-->
            <!--</div>-->
          <!--</div>-->
            <div class="people-container">
                <div class="people-single" v-for="item of $t('pages.about.peopleList')">
                    <div class="photo">
                        <img :src="item.photoUrl" alt="">
                    </div>
                    <div class="info">
                        <h4>{{item.name}}<span>{{item.title}}</span></h4>
                        <p v-html="item.intro"></p>
                    </div>
                </div>
            </div>

        </div>
      </li>
    </ul>
  </div>
</template>
<style type="text/css">
  .p1-img{

  }
</style>
<script type="text/ecmascript-6" lang="babel">
  import $ from 'jquery';
  import aboutApi from '@/api/about';
  import newsApi from '@/api/news';
  import opSwiper from '@/components/op-swiper';
  import InfiniteLoading from 'vue-infinite-loading';

  export default {
    data() {
      return {
        isPC: window.isPC,
        slideList: [],
        about: {},
        news: [],
        listData: [{
          key: 'introductionHTML',
          title: 'pages.about.introduction',
          detailHtml: '<div>detail</div>'
        }],
        partners: [{
          links: 'https://meizhuang.tmall.com/',
          imgurl: require('../../assets/img/partner/p1.png'),
          content: '天猫美妆是天猫平台的独立美妆垂直市场，由众多美容美妆护理类的名牌旗舰店直供美妆正品，商品涵盖面部护肤、时尚彩妆、精油芳疗、美体瘦身、男士护肤、假发、香水、试用、底价抢购服务等网购服务，是天猫平台的一个重要品牌。'
        }, {
          links: 'http://www.pinguan.com/',
          imgurl: require('../../assets/img/partner/p2.png'),
          content: '品观网是目前中国最权威的化妆品产业媒体平台，也是中国化妆品行业中最具影响力的品牌传播与招商平台。品观网在中国乃至全球化妆品产业中拥有广泛而优质的合作资源，是中国市场上的一线以及二线化妆品品牌的首选合作媒体。'
        }, {
          links: 'https://www.kantarworldpanel.com/global',
          imgurl: require('../../assets/img/partner/p3.png'),
          content: ' 凯度是全球领先的数据、洞察和咨询公司之一。凯度旗下的专业品牌及全球三万多名员工向全球100个国家的客户提供全面的调研及咨询服务，为他们提供启发灵感的研究洞察和商业战略规划，凯度的母公司是全球传播集团WPP集团。'
        }, {
          links: 'https://good.tmall.com/',
          imgurl: require('../../assets/img/partner/p4.png'),
          content: '淘宝心选是阿里巴巴全新推出的一个生活方式品牌，试营业时间为2017年5月26到6月26日。店铺仅有包括硅胶枕、玻璃杯、脚垫在内的六款商品，淘宝心选上线一年以来，已经有超过2000个SKU[库存量单位]和800多个标准产品单位，将近1亿人次的访问量，其中2/3为女性。'
        }, {
          links: 'http://www.pentawards.org/',
          imgurl: require('../../assets/img/partner/p5.png'),
          content: 'Pentawards是全球首个也是唯一的专注于各种包装设计的竞赛，素有包装设计界奥斯卡之称。自2007年创办起，每年竞赛皆会聘请12名专业的国际评审, 根据作品的创意品质与市场相关性选出优胜者，并颁发铜质、银质、金质、铂金、钻石五类大奖。'
        }, {
          links: 'http://china.mintel.com/',
          imgurl: require('../../assets/img/partner/p6.png'),
          content: '英敏特是全球领先的独立市场研究咨询公司，帮您深入了解市场，为您洞察未来的商机，助您把创新脉搏，与您解读消费趋势。研究消费者，助您创新，评估市场与预测未来趋势。'
        }],
        partners2: [{
          links: 'https://meizhuang.tmall.com/',
          imgurl: require('../../assets/img/partner/p8-m.png')
        }, {
          links: 'https://www.kantarworldpanel.com/global',
          imgurl: require('../../assets/img/partner/p2-m.png')
        }, {
          links: 'http://www.pentawards.org/',
          imgurl: require('../../assets/img/partner/p3-m.png')
        }, {
          links: 'http://www.pinguan.com/',
          imgurl: require('../../assets/img/partner/p9-m.png')
        }, {
          links: 'https://good.tmall.com/ ',
          imgurl: require('../../assets/img/partner/p5-m.png')
        }, {
          links: 'http://china.mintel.com/',
          imgurl: require('../../assets/img/partner/p6-m.png')
        }],
        newsData: [{
          key: 'awardHTML',
          title: 'pages.about.awards',
          detailHtml: '<a href="http://www.oib-china.com/#/zh_cn/news/1" style="font-weight:600;color: #E60000;">数十位行业大咖齐聚CBF，把做品牌这件事说透了</a>'
        }]
      };
    },
    components: {
      opSwiper
    },
    mounted() {
      $('.about .list h3')
        .on('mouseenter', function () {
          $(this).addClass('active');
        })
        .on('mouseleave', function () {
          $(this).removeClass('active');
        })
        .on('click', function () {
          $(this).next().toggle();
        });
    },
    async created() {
      this.slideList = (await aboutApi.getSliders()).sliders;
      this.about = await aboutApi.get();
      if (this.about.zh_cn || this.about.en) {
        this.listData = this.listData.map(item => Object.assign(item, {
          detailHtml: `about.detail.${item.key}`
        }));
        ['zh_cn', 'en'].forEach((lang) => {
          this.$i18n.mergeLocaleMessage(lang, {
            about: {
              detail: Object.assign({}, this.about, this.about[lang])
            }
          });
        });
      }
      this.getNews();
    },
    methods: {
      async getNews () {
        let news = await newsApi.list({
          enable: 1,
          page: 1,
          rows: 100
        });
        console.log('news', news);
        this.news = news.content;
      }
    }
  };
</script>



// WEBPACK FOOTER //
// src/pages/about/about.vue